import React from "react";
import { Alert, Box, Button, Paper, Stack, Typography } from "@mui/material";

// Fixed bottom bar for the primary CTA on mobile (basket, add to basket, checkout).
// Reserve room for it on the page with <StickyBarSpacer />.
export function StickyBar({ children, ...props }) {
  return (
    <Paper
      elevation={0}
      square
      {...props}
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: (t) => t.zIndex.appBar,
        px: 2,
        pt: 1.5,
        pb: "max(12px, env(safe-area-inset-bottom))",
        borderTop: "1px solid",
        borderColor: "divider",
        boxShadow: "0 -4px 16px rgba(28, 28, 78, 0.08)",
        ...props.sx,
      }}
    >
      <Box sx={{ maxWidth: 720, mx: "auto" }}>{children}</Box>
    </Paper>
  );
}

export const StickyBarSpacer = () => <Box sx={{ height: 88 }} aria-hidden />;

export function EmptyState({ icon, title, message, actionLabel, onAction }) {
  return (
    <Stack alignItems="center" spacing={1.5} sx={{ py: 6, px: 3, textAlign: "center" }}>
      {icon && <Box sx={{ color: "text.secondary", "& svg": { fontSize: 56 } }}>{icon}</Box>}
      <Typography variant="h5" component="h2">
        {title}
      </Typography>
      {message && (
        <Typography color="text.secondary" sx={{ maxWidth: 360 }}>
          {message}
        </Typography>
      )}
      {actionLabel && (
        <Button onClick={onAction} sx={{ mt: 1 }}>
          {actionLabel}
        </Button>
      )}
    </Stack>
  );
}

export function ErrorState({ title = "Something went wrong", message, onRetry }) {
  return (
    <EmptyState
      title={title}
      message={message || "Please check your connection and try again."}
      actionLabel={onRetry ? "Try again" : undefined}
      onAction={onRetry}
    />
  );
}

// Persistent inline message (unlike a snackbar it stays until the user changes the input).
export function InlineMessage({ severity = "error", children, ...props }) {
  if (!children) return null;
  return (
    <Alert severity={severity} role="alert" sx={{ borderRadius: 2, alignItems: "center" }} {...props}>
      {children}
    </Alert>
  );
}
